/* eslint-disable object-shorthand */
/* eslint-disable padded-blocks */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */

import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import {
  AimOutlined,
  BarsOutlined,
  EditOutlined,
  HomeOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
  UserOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
  PlusOutlined,
  SaveOutlined,
  ReloadOutlined,
} from '@ant-design/icons';

import { onError, onSuccess } from 'utils/handlers';
import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Spin,
  Tabs,
  TreeSelect,
  Modal,
  Checkbox,
  Button,
  notification,
  Alert,
  Switch,
} from 'antd';

import { getPaises } from 'api/catalogos/paises';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import { getPlazasDeArea } from 'api/catalogos/plazas';
import currencyFormatter from 'utils/currencyFormatter';
import API from 'utils/api';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { URIconfiguracionesDeSegmentosPresupuestales } from 'utils/URIsSac';
import {
  CAMPO_POR_COLUMNA,
  getSegmentosDeConfiguracion,
  segmentoAplica,
} from 'utils/segmentosPresupuestales';
import DireccionEntidad from 'components/Entity/DireccionEntidad';
import Select from 'components/Select';
import Table from 'components/Table';
import { formsRules, generateRFCRules } from 'utils/rules';
import makeMessager from 'utils/complexFormsMessages';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarEstructuraJerarquica,
  cloneEstructuraJerarquica,
  deleteEstructuraJerarquica,
  getAllEstructurasJerarquicas,
  updateEstructuraJerarquica,
} from 'api/catalogos/estructuraJerarquica';
import {
  autorizarArea,
  createArea,
  deleteArea,
  getAllAreas,
  getCostoDeArea,
  updateArea,
} from 'api/catalogos/DirectorioAreas';
import ModalConfirmation from 'components/ModalConfirmation';
import { getAllNivelesJerarquicos } from 'api/catalogos/NivelJerarquico';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
  TIPO_PRESUPUESTO_EGRESO,
} from 'utils/constants';
import makeTree from 'utils/makeTree';
import { render } from '@testing-library/react';
import {
  createMisionVision,
  getAllMisionesVisiones,
  getMisionVisionByDirectorioAreaID,
  updateMisionVisionById,
} from 'api/catalogos/misionVisionAreas';
import { DATE_FORMATS } from 'utils/normalizers';
import { formatDistanceStrict } from 'date-fns';
import { createDireccion, getAllDirecciones, getDireccionesByDirectorioAreaID } from 'api/catalogos/DireccionesHistoricoAreas';
import { getTiposDeVialidades } from 'api/catalogos/tiposVialidades';
import { is } from 'date-fns/locale';
import { add } from 'lodash';
import ModalDelete from 'components/ModalDelete';

export const directorioAreasPermission = {
  permissionModel: 'directoriodearea',
  hasViewPermission: true,
  catalogsModels: ['periodofiscal'],
  tabsModels: [],
};

const { TextArea } = Input;
const baseURI = 'catalogos/directorio-de-areas';

function DirectorioAreas({ permission }) {
  // #region useState
  const [mainForm] = Form.useForm();
  const [addingEditingForm] = Form.useForm();
  const [misionVisionModalForm] = Form.useForm();
  const [misionVisionVisibleForm] = Form.useForm();
  const [endDateAddressForm] = Form.useForm();
  const [formUbicacion] = Form.useForm();
  // const [cloningForm] = Form.useForm();
  const [formDireccion] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [coloniasCargadas] = useState([]);
  const [paises, setPaises] = useState([]);
  const [isLoadingVisible, setIsLoadingVisible] = useState(false);
  const [tablaPlazasDataSource, setTablaPlazasDataSource] = useState([]);
  const [tablaPlazasDesgloseDataSource, setTablaPlazasDesgloseDataSource] = useState([]);
  const [tablaPuestosGlobalDataSource, setTablaPuestosGlobalDataSource] = useState([]);
  const [costoArea, setCostoArea] = useState({ periodo_fiscal: null, claves: [] });
  const [costoPeriodoFiscal, setCostoPeriodoFiscal] = useState(null); // null = ejercicio en curso
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [segmentosEgreso, setSegmentosEgreso] = useState(); // undefined = aún no se consultan
  const [loadingCosto, setLoadingCosto] = useState(false);
  const [disabled] = useState(true);
  const [directorioDeAreasActual, setDirectorioDeAreasActual] = useState([]);
  const [directorioDeAreasActualTree, setDirectorioDeAreasActualTree] = useState([]);
  const [directorioDeAreasActualNormalizadaTreeSelect, setDirectorioDeAreasActualNormalizadaTreeSelect] = useState([]);
  const [directorioDeAreasCompleto, setDirectorioDeAreasCompleto] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedEstructuraJerarquica, setSelectedEstructuraJerarquica] = useState(null);
  const [estructurasJerarquicas, setEstructurasJerarquicas] = useState([]);
  const [nivelesJerarquicos, setNivelesJerarquicos] = useState([]);
  const [isModalAuthorizeAreaVisible, setIsModalAuthorizeAreaVisible] = useState(false);
  const [isAddingAreaMode, setIsAddingAreaMode] = useState(false);
  const [isEditingAreaMode, setIsEditingAreaMode] = useState(false);
  const [isNivelesJerarquicosDisabled, setIsNivelesJerarquicosDisabled] = useState(false);
  const [isTreeSelectDisabled, setIsTreeSelectDisabled] = useState(false);
  const [misionesVisiones, setMisionesVisiones] = useState([]);
  const [isMisionVisionModalVisible, setIsMisionVisionModalVisible] = useState(false);
  const [isAddingMisionVisionMode, setIsAddingMisionVisionMode] = useState(false);
  const [isEdittingMisionVisionMode, setIsEdittingMisionVisionMode] = useState(false);
  const [isAddingAddressMode, setIsAddingAddressMode] = useState(false);
  const [isEditingAddressMode, setIsEditingAddressMode] = useState(false);
  const [isAddingLocationMode, setIsAddingLocationMode] = useState(false);
  const [isEditingLocationMode, setIsEditingLocationMode] = useState(false);
  const [isAddressFormDisabled, setIsAddressFormDisabled] = useState(false);
  const [dataMisionesHistorico, setDataMisionesHistorico] = useState([]);
  const [historicoDirecciones, setHistoricoDirecciones] = useState([]);
  const [tiposVialidades, setTiposVialidades] = useState([]);
  const [isLocationFormDisabled, setIsLocationFormDisabled] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  // Tabs edicion
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [mutable, setMutable] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [columnFilters, setColumnFilters] = useState({});
  const [showColumnFilterWarning, setShowColumnFilterWarning] = useState(false);

  const [expandAll, setExpandAll] = useState(false); // Controla el switch
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const { TabPane } = Tabs;
  // #endregion useState

  // #region functions
  const normalize = (_data = []) => _data.map((item) => {
    const clone = { ...item };
    const children = clone.children?.length && !clone.seleccionable
      ? normalize(clone.children) : [];
    if (!children.length) {
      delete clone.children;
      return ({
        ...clone,
        key: clone.clave,
        clave: clone.clave,
        seleccionable: !clone.seleccionable,
        disabled: clone.seleccionable,
      });
    }
    return ({
      ...clone,
      key: `${clone.clave}_padre`,
      children,
      disabled: !clone.seleccionable,
      seleccionable: clone.seleccionable,
    });
  });

  const createArbolDirectorioActual = (areasActuales) => {
    if (!areasActuales) return;
    const tree = makeTree(areasActuales, 'directorio_area_padre');
    const treeNormalized = normalize(tree);
    setDirectorioDeAreasActualTree(treeNormalized);
  };

  const buildAreaPaths = (areasData) => {
    const areaMap = new Map(areasData.map((a) => [a.id, a]));
    return areasData.map((area) => {
      const path = [];
      let current = area;
      while (current) {
        path.unshift(current.nombre.trim());
        current = areaMap.get(current.directorio_area_padre);
      }
      return {
        ...area,
        path: path.join(' / '),
      };
    });
  };

  const normalizeTreeSelect = (dataTree) => {
    const sortedData = buildAreaPaths(dataTree).sort((a, b) => a.clave.localeCompare(b.clave));
    const map = new Map();
    const tree = [];
    sortedData.forEach((item) => {
      const node = {
        title: `${item.clave} - ${item.nombre.trim()}`,
        value: item.id,
        key: item.id,
        children: [],
        path: item.path,
      };
      map.set(item.id, node);
    });
    sortedData.forEach((item) => {
      const parentId = item.directorio_area_padre;
      if (parentId && map.has(parentId)) {
        const parent = map.get(parentId);
        parent.children.push(map.get(item.id));
        parent.disabled = false;
      } else {
        tree.push(map.get(item.id));
      }
    });
    return tree;
  };

  const reloadAreasTable = (responseAreas = null) => {
    if (!selectedEstructuraJerarquica) return;

    const areasFiltered = responseAreas
      ? responseAreas.filter((area) => area.estructura_jerarquica === selectedEstructuraJerarquica.id)
      : directorioDeAreasCompleto.filter((area) => area.estructura_jerarquica === selectedEstructuraJerarquica.id);

    const areasWithPaths = buildAreaPaths(areasFiltered);
    const normalizadosTreeSelect = normalizeTreeSelect(areasWithPaths);
    createArbolDirectorioActual(areasWithPaths);
    setDirectorioDeAreasActual(areasWithPaths);
    setDirectorioDeAreasActualNormalizadaTreeSelect(normalizadosTreeSelect);
  };

  const fetchInitialData = async (reloadTable = false) => {
    setIsLoadingVisible(true);
    const [
      _paises,
      _directorioDeAreas,
      _estructurasJerarquicas,
      _nivelesJerarquicos,
      _misionesVisiones,
      _tiposDeVialidades,
    ] = await Promise.all([
      getPaises(),
      getAllAreas(),
      getAllEstructurasJerarquicas(),
      getAllNivelesJerarquicos(),
      getAllMisionesVisiones(),
      getTiposDeVialidades(),
    ]);
    setPaises(_paises);
    setDirectorioDeAreasCompleto(_directorioDeAreas);
    setEstructurasJerarquicas(_estructurasJerarquicas);
    setNivelesJerarquicos(_nivelesJerarquicos);
    setMisionesVisiones(_misionesVisiones);
    setTiposVialidades(_tiposDeVialidades);
    if (reloadTable) {
      reloadAreasTable(_directorioDeAreas);
    }
    setIsLoadingVisible(false);
  };

  const complexForms = [];
  const basicKeys = [
    'general',
    'parametrizacion',
    'asignacion',
    'registro',
    'importe',
  ];
  const estadosGlobalesConst = [
    { value: 1, descripcion: 'ACTIVO' },
    { value: 2, descripcion: 'EN PROCESO' },
    { value: 3, descripcion: 'INACTIVO' },
    { value: 4, descripcion: 'AUTORIZADO' },
    { value: 5, descripcion: 'CANCELADO' },
    { value: 6, descripcion: 'RECHAZADO' },
  ];
  const showMsg = makeMessager(setCurrentTabKey);
  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );



  // Función para encontrar el nombre de la Coordinación (Nivel 1)
  const getNombreCoordinacion = (parentId) => {
    if (!parentId) return '';

    // 1. Convertimos el array a un Map para búsquedas instantáneas
    // Esto evita usar .find() dentro del while y soluciona el error de ESLint
    const areaMap = new Map();
    directorioDeAreasCompleto.forEach((area) => {
      areaMap.set(area.id, area);
    });

    // 2. Obtenemos el área inicial
    let areaActual = areaMap.get(parentId);

    if (!areaActual) return '';

    // 3. Recorremos hacia arriba usando el Map
    while (areaActual.directorio_area_padre) {
      const padre = areaMap.get(areaActual.directorio_area_padre);

      // Si no encontramos al padre en el mapa, nos detenemos en el actual
      if (!padre) break;

      areaActual = padre;
    }

    return areaActual.nombre;
  };

  const onClickSaveAddress = async () => {
    if (isAddingAreaMode) {
      const formAddressValidation = await formDireccion.validateFields();
      const formEndDateValidation = await endDateAddressForm.validateFields();
      if (formAddressValidation && formEndDateValidation) {
        setIsAddingAddressMode(false);
        setIsEditingAddressMode(false);
        setIsAddressFormDisabled(true);
      }
    } else {
      const formAddressValidation = await formDireccion.validateFields();
      const formEndDateValidation = await endDateAddressForm.validateFields();
      if (!formAddressValidation || !formEndDateValidation) return;
      const endDateFormValues = endDateAddressForm.getFieldsValue();
      const formDireccionValues = formDireccion.getFieldsValue();
      const parameter = {
        directorio_area: selectedArea.id,
        vigencia_final: endDateFormValues.vigencia_final.format(DATE_FORMATS[1]),
        calle_principal: formDireccionValues.calle_principal,
        entre_calle: formDireccionValues.entre_calle,
        y_calle: formDireccionValues.y_calle,
        numero_exterior: formDireccionValues.numero_exterior,
        numero_interior: formDireccionValues.numero_interior,
        descripcion_de_la_ubicacion: formDireccionValues.descripcion_de_la_ubicacion,
        colonia: formDireccionValues.colonia,
        codigo_postal: formDireccionValues.d_codigo,
        tipo_de_vialidad: formDireccionValues.tipo_de_vialidad,
        tipo_de_vialidad_entre: formDireccionValues.tipo_de_vialidad_entre,
        tipo_de_vialidad_y_calle: formDireccionValues.tipo_de_vialidad_y_calle,
      };
      try {
        const response = await createDireccion(parameter);
        if (!response) return;
        setIsAddingAddressMode(false);
        setIsEditingAddressMode(false);
        setIsAddressFormDisabled(true);
        const allAddresses = await getDireccionesByDirectorioAreaID(selectedArea.id);
        setHistoricoDirecciones(allAddresses);
      } catch (error) {
        onError(error, setIsLoadingVisible);
      } finally {
        setIsLoadingVisible(false);
      }
    }
  };

  const cargarDirecciones = async () => {
    const addressesAreaResponse = await getDireccionesByDirectorioAreaID(selectedArea.id);
    if (addressesAreaResponse.length === 0) {
      formDireccion.resetFields();
      endDateAddressForm.resetFields();
      setHistoricoDirecciones([]);
    } else {
      const lastAddress = addressesAreaResponse[addressesAreaResponse.length - 1];
      formDireccion.setFieldsValue({
        ...lastAddress,
        d_codigo: lastAddress.codigo_postal.id,
        estado: lastAddress.codigo_postal.municipio?.estado.nombre_de_AGEE,
        municipio: lastAddress.codigo_postal.municipio?.nom_mun,
      });
      endDateAddressForm.setFieldsValue({
        vigencia_final: Moment(lastAddress.vigencia_final),
      });
      setIsAddressFormDisabled(true);
      setHistoricoDirecciones(addressesAreaResponse);
    }
  };

  const onClickCancelAddress = async () => {
    formDireccion.resetFields();
    endDateAddressForm.resetFields();
    if (isEditingAreaMode) {
      await cargarDirecciones();
    }
    setIsAddressFormDisabled(true);
    setIsAddingAddressMode(false);
    setIsEditingAddressMode(false);
  };

  const onClickAddLocation = () => {
    setIsAddingLocationMode(true);
    setIsEditingLocationMode(false);
    setIsLocationFormDisabled(false);
    formUbicacion.resetFields();
  };

  const onClickSaveLocation = async () => {
    if (isAddingAreaMode) {
      setIsAddingLocationMode(false);
      setIsEditingLocationMode(false);
      setIsLocationFormDisabled(true);
    } else {
      const parameter = {
        ...formUbicacion.getFieldsValue(),
      };
      try {
        const response = await updateArea(selectedArea.id, parameter);
        if (!response) return;
        await fetchInitialData(true);
        setIsAddingLocationMode(false);
        setIsEditingLocationMode(false);
        setIsLocationFormDisabled(true);
      } catch (error) {
        onError(error, setIsLoadingVisible);
      } finally {
        setIsLoadingVisible(false);
      }
    }
  };

  const onClickCancelLocation = () => {
    formUbicacion.resetFields();
    if (isEditingAreaMode) {
      formUbicacion.setFieldsValue({
        edificio_especificacion: selectedArea?.edificio_especificacion || null,
        edificio_orientacion: selectedArea?.edificio_orientacion || null,
        edificio_observaciones: selectedArea?.edificio_observaciones || null,
        piso_especificacion: selectedArea?.piso_especificacion || null,
        piso_orientacion: selectedArea?.piso_orientacion || null,
        piso_observaciones: selectedArea?.piso_observaciones || null,
        area_especificacion: selectedArea?.area_especificacion || null,
        area_orientacion: selectedArea?.area_orientacion || null,
        area_observaciones: selectedArea?.area_observaciones || null,
        oficina_especificacion: selectedArea?.oficina_especificacion || null,
        oficina_orientacion: selectedArea?.oficina_orientacion || null,
        oficina_observaciones: selectedArea?.oficina_observaciones || null,
        otros_especificacion: selectedArea?.otros_especificacion || null,
        otros_orientacion: selectedArea?.otros_orientacion || null,
        otros_observaciones: selectedArea?.otros_observaciones || null,
      });
    }
    setIsLocationFormDisabled(true);
    setIsAddingLocationMode(false);
    setIsEditingLocationMode(false);
  };

  const cargarMisionesVisiones = async () => {
    const misionVisionAreaResponse = await getMisionVisionByDirectorioAreaID(selectedArea.id);
    if (misionVisionAreaResponse.length === 0) {
      misionVisionVisibleForm.resetFields();
      setDataMisionesHistorico([]);
    } else {
      const lastMission = misionVisionAreaResponse[misionVisionAreaResponse.length - 1];
      misionVisionVisibleForm.setFieldsValue({
        misionActual: lastMission.vision,
        visionActual: lastMission.mision,
        vigenciaFinalActual: Moment(lastMission.vigencia_final),
      });
      setDataMisionesHistorico(misionVisionAreaResponse);
    }
  };

  const onClickAddArea = () => {
    addingEditingForm.setFieldsValue({
      nombre_estructuraJerarquica: selectedEstructuraJerarquica?.nombre,
      vigenteHasta_estructuraJerarquica: selectedEstructuraJerarquica?.vigencia_fin ? Moment(selectedEstructuraJerarquica?.vigencia_fin) : null,
      estatus_estructuraJerarquica: estadosGlobalesConst.find((estado) => estado.value === selectedEstructuraJerarquica?.estados_globales)?.descripcion || null,
    });
    setIsAddingAreaMode(true);
    setIsEditingAreaMode(false);
    setCurrentTabKey('general');
  };

  const onClickEditArea = async () => {
    const estructuraJerarquica = estructurasJerarquicas.find((estructura) => estructura.id === selectedEstructuraJerarquica.id);
    const areaSeleccionada = selectedArea;
    const nivelJerarquicoSelecccionado = nivelesJerarquicos.find((nivelJerarquico) => nivelJerarquico.nivel === areaSeleccionada?.nivel_jerarquico - 1) || null;
    const nombreCoordinacion = getNombreCoordinacion(selectedArea.directorio_area_padre);
    addingEditingForm.setFieldsValue({
      nombre_estructuraJerarquica: estructuraJerarquica?.nombre,
      vigenteHasta_estructuraJerarquica: selectedEstructuraJerarquica?.vigencia_fin ? Moment(selectedEstructuraJerarquica?.vigencia_fin) : null,
      estatus_estructuraJerarquica: estadosGlobalesConst.find((estado) => estado.value === estructuraJerarquica?.estados_globales)?.descripcion || null,
      nivelSuperior_areas: selectedArea.directorio_area_padre,
      coordinacion_areas: nombreCoordinacion,
      clave_areas: areaSeleccionada?.clave,
      nombre_areas: areaSeleccionada?.nombre,
      nivelJerarquico_areas: Number(nivelJerarquicoSelecccionado?.nivel + 1 ?? 0),
      estatus_areas: estadosGlobalesConst.find((estado) => estado.value === areaSeleccionada.estados_globales)?.descripcion || '',

    });

    // mision/vision
    await cargarMisionesVisiones();

    // direcciones
    await cargarDirecciones();

    // ubicación
    formUbicacion.setFieldsValue({
      edificio_especificacion: selectedArea?.edificio_especificacion || null,
      edificio_orientacion: selectedArea?.edificio_orientacion || null,
      edificio_observaciones: selectedArea?.edificio_observaciones || null,
      piso_especificacion: selectedArea?.piso_especificacion || null,
      piso_orientacion: selectedArea?.piso_orientacion || null,
      piso_observaciones: selectedArea?.piso_observaciones || null,
      area_especificacion: selectedArea?.area_especificacion || null,
      area_orientacion: selectedArea?.area_orientacion || null,
      area_observaciones: selectedArea?.area_observaciones || null,
      oficina_especificacion: selectedArea?.oficina_especificacion || null,
      oficina_orientacion: selectedArea?.oficina_orientacion || null,
      oficina_observaciones: selectedArea?.oficina_observaciones || null,
      otros_especificacion: selectedArea?.otros_especificacion || null,
      otros_orientacion: selectedArea?.otros_orientacion || null,
      otros_observaciones: selectedArea?.otros_observaciones || null,
    });
    setIsAddingAreaMode(false);
    setIsEditingAreaMode(true);
  };

  const onCancelAddEditArea = () => {
    setIsAddingAreaMode(false);
    setIsEditingAreaMode(false);

    // areas
    addingEditingForm.resetFields();

    // mision-vision
    misionVisionModalForm.resetFields();
    misionVisionVisibleForm.resetFields();
    setDataMisionesHistorico([]);

    // direccion
    formDireccion.resetFields();
    endDateAddressForm.resetFields();
    setHistoricoDirecciones([]);
    setIsAddressFormDisabled(true);
    setIsAddingAddressMode(false);
    setIsEditingAddressMode(false);

    // ubicación
    formUbicacion.resetFields();
    setIsLocationFormDisabled(true);
    setIsAddingLocationMode(false);
    setIsEditingLocationMode(false);

    // sepa que sea esto
    setMutable(true);
    setSelectedRowKeys([]);
    setCurrentTabKey('general');
  };


  // const onCancelAddEditArea = () => {
  //   setIsTreeSelectDisabled(false);
  //   setIsAddingAreaMode(false);
  //   setIsEditingAreaMode(false);
  //   setSelectedRowKeys([]);

  //   // areas
  //   addingEditingForm.resetFields();

  //   // mision y vision
  //   misionVisionModalForm.resetFields();
  //   misionVisionVisibleForm.resetFields();

  //   // sepa que sea esto
  //   setMutable(true);
  //   setCurrentTabKey('general');

  // };







  const onFinishAddEditArea = async () => {
    // setIsLoadingVisible(true);
    const areaSeleccionada = directorioDeAreasActual.find((area) => area.id === selectedArea?.id) || null;
    const addingEditingFormValues = addingEditingForm.getFieldsValue();
    let createdAreaProcess = null;
    if (isAddingAreaMode) {
      const newAreaParameter = {
        // Areas (No mover, completado)
        directorio_area_padre: addingEditingFormValues.nivelSuperior_areas || null,
        clave: addingEditingFormValues.clave_areas,
        nombre: addingEditingFormValues.nombre_areas,
        estructura_jerarquica: selectedEstructuraJerarquica.id,
        nivel_jerarquico: addingEditingFormValues.nivelJerarquico_areas,
        estados_globales: ESTATUS_ACTIVO,
      };
      try {
        const newAreaResponse = await createArea(newAreaParameter);
        if (!newAreaResponse) return;
        createdAreaProcess = newAreaResponse;
      } catch (error) {
        onError(error, setIsLoadingVisible);
      } finally {
        setIsLoadingVisible(false);
      }
      await fetchInitialData(true);
      setSelectedArea(createdAreaProcess);


      // Misiones (Completado)
      const misionVisionValues = misionVisionVisibleForm.getFieldsValue();
      const newMisionVisionParameter = {
        directorio_area: createdAreaProcess.id,
        mision: misionVisionValues?.misionActual || '',
        vision: misionVisionValues?.visionActual || '',
        vigencia_final: Moment(misionVisionValues?.vigenciaFinalActual).format(DATE_FORMATS[1]) || '',
      };
      try {
        const newMisionVisionResponse = await createMisionVision(newMisionVisionParameter);
        if (!newMisionVisionResponse) return;
      } catch (error) {
        onError(error, setIsLoadingVisible);
      } finally {
        setIsLoadingVisible(false);
      }
      // fin misiones (completado)

      // Dirección (completo)
      const endDateFormValues = endDateAddressForm.getFieldsValue();
      const formDireccionValues = formDireccion.getFieldsValue();
      const newAddressParameter = {
        directorio_area: createdAreaProcess.id,
        vigencia_final: endDateFormValues.vigencia_final.format(DATE_FORMATS[1]),
        calle_principal: formDireccionValues.calle_principal,
        entre_calle: formDireccionValues.entre_calle,
        y_calle: formDireccionValues.y_calle,
        numero_exterior: formDireccionValues.numero_exterior,
        numero_interior: formDireccionValues.numero_interior,
        descripcion_de_la_ubicacion: formDireccionValues.descripcion_de_la_ubicacion,
        colonia: formDireccionValues.colonia,
        codigo_postal: formDireccionValues.d_codigo,
        tipo_de_vialidad: formDireccionValues.tipo_de_vialidad,
        tipo_de_vialidad_entre: formDireccionValues.tipo_de_vialidad_entre,
        tipo_de_vialidad_y_calle: formDireccionValues.tipo_de_vialidad_y_calle,
      };
      try {
        const response = await createDireccion(newAddressParameter);
        if (!response) return;
        const allAddresses = await getAllDirecciones();
        setHistoricoDirecciones(allAddresses);
      } catch (error) {
        onError(error, setIsLoadingVisible);
      } finally {
        setIsLoadingVisible(false);
      }
      // fin dirección


      // Ubicación (completo)

      const ubicacionValues = formUbicacion.getFieldsValue();
      const newLocationParameter = {
        ...ubicacionValues,
      };
      try {
        const response = await updateArea(createdAreaProcess.id, newLocationParameter);
        if (!response) return;
      } catch (error) {
        onError(error, setIsLoadingVisible);
      } finally {
        setIsLoadingVisible(false);
      }
      // fin Ubicación
      await fetchInitialData(true);
    } else if (isEditingAreaMode) {
      // actualizar area
      const formValues = addingEditingForm.getFieldsValue();
      if (formValues.nivelSuperior_areas === selectedArea?.id) {
        notification.error({
          message: 'Error',
          description: 'No se puede seleccionar la misma área como padre, seleccione una área distinta.',
        });
        return;
      }
      const areaParameter = {
        directorio_area_padre: formValues.nivelSuperior_areas || null,
        clave: formValues.clave_areas,
        nombre: formValues.nombre_areas,
        nivel_jerarquico: formValues.nivelJerarquico_areas,
      };
      try {
        await updateArea(areaSeleccionada.id, areaParameter);
        await fetchInitialData(true);
        setMutable(true);
        setCurrentTabKey('general');
        setIsAddingAreaMode(false);
        setIsEditingAreaMode(false);
      } catch (error) {
        onError(error, setLoading);
      } finally {
        setIsLoadingVisible(false);
      }
    }
    onCancelAddEditArea();
  };

  const onClickAddMisionVision = () => {
    setIsAddingMisionVisionMode(true);
    setIsEdittingMisionVisionMode(false);
    misionVisionModalForm.resetFields();
    setIsMisionVisionModalVisible(true);
  };

  const onClickAddAddress = () => {
    setIsAddingAddressMode(true);
    setIsEditingAddressMode(false);
    setIsAddressFormDisabled(false);
    formDireccion.resetFields();
    endDateAddressForm.resetFields();
  };

  const onClickEditMisionVision = () => {
    setIsAddingMisionVisionMode(false);
    setIsEdittingMisionVisionMode(true);
    setIsMisionVisionModalVisible(true);
    misionVisionModalForm.resetFields();
    const visibleFormValues = misionVisionVisibleForm.getFieldsValue();
    misionVisionModalForm.setFieldsValue({
      mision: visibleFormValues.misionActual,
      vision: visibleFormValues.visionActual,
      vigencia_final: visibleFormValues.vigenciaFinalActual,
    });
  };

  const searchInNodeOrDescendants = (record, searchValue) => {
    if (!searchValue || searchValue.trim() === '') return true;

    const lowerValue = searchValue.toLowerCase().trim();

    const title = `${record.clave || ''} - ${record.nombre || ''}`.toLowerCase();
    if (title.includes(lowerValue)) return true;

    if (record.path && record.path.toLowerCase().includes(lowerValue)) return true;

    if (record.children && record.children.length > 0) {
      return record.children.some((child) => searchInNodeOrDescendants(child, searchValue));
    }

    return false;
  };

  const filterTreeRecursively = (nodes) => {
    const hasActiveColumnFilters = Object.values(columnFilters).some((val) => val && val.trim() !== '');
    const hasGlobalSearch = searchText.trim() !== '';

    if (!hasActiveColumnFilters && !hasGlobalSearch) {
      return nodes;
    }

    return nodes
      .map((node) => {
        let shouldKeep = false;

        // Prioridad al buscador global (si está activo)
        if (hasGlobalSearch && searchInNodeOrDescendants(node, searchText)) {
          shouldKeep = true;
        }

        // Si no coincidió con global, pero sí con algún filtro de columna
        if (!shouldKeep && hasActiveColumnFilters) {
          shouldKeep = Object.entries(columnFilters).some(([key, value]) => {
            if (!value || value.trim() === '') return false;
            const lowerValue = value.toLowerCase().trim();
            const nodeValue = (node[key] || '').toString().toLowerCase();
            return nodeValue.includes(lowerValue);
          });
        }

        let filteredChildren = [];
        if (node.children && node.children.length > 0) {
          filteredChildren = filterTreeRecursively(node.children);
          if (filteredChildren.length > 0) {
            shouldKeep = true;
          }
        }

        if (!shouldKeep) return null;

        return {
          ...node,
          children: filteredChildren.length > 0 ? filteredChildren : undefined,
        };
      })
      .filter(Boolean);
  };
  // #endregion functions

  // #region variables

  const rowSelection = {
    selectedRowKeys,
    type: 'checkbox', // <--- CAMBIO: De 'radio' a 'checkbox' (Requerimiento 2)
    onChange: (keys, selectedRows) => {
      setSelectedRowKeys(keys);
      // Si seleccionas solo uno, mantenemos la lógica de selectedArea para edición
      // Si seleccionas varios, selectedArea será el último (o null, depende de tu lógica de negocio para edición)
      if (selectedRows.length === 1) {
        setSelectedArea(selectedRows[0]);
      } else {
        setSelectedArea(null); // Deshabilitamos edición individual si hay múltiples
      }
    },
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedArea(record);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 100,
    },
    {
      titleText: 'Área',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 200,
    },
    // {
    //   titleText: 'Misión',
    //   dataIndex: 'mision',
    //   key: 'mision',
    //   width: 100,
    // },
    // {
    //   titleText: 'Visión',
    //   dataIndex: 'vision',
    //   key: 'vision',
    //   width: 100,
    // },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      render: (rowInfo) => {
        const estado = estadosGlobalesConst.find((current) => current.value === rowInfo)?.descripcion;
        return estado;
      },
      width: 100,
    },
  ];

  const columnsMisionesHistorico = [
    {
      titleText: 'Misión',
      dataIndex: 'mision',
      key: 'mision',
      width: 200,
    },
    {
      titleText: 'Visión',
      dataIndex: 'vision',
      key: 'vision',
      width: 200,
    },
    {
      titleText: 'Vigente Hasta',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 200,
    },
  ];

  // const dataMisionesHistorico = [{
  //   id: 1,
  //   mision: 'Administrar los recursos humanos y materiales a todas las Dependencias y Organismos Descentralizados, que conforman la Administración Pública Municipal, aplicando la normatividad vigente, actuando de forma honesta, eficaz, eficiente y transparente, con el fin de garantizar el buen desarrollo de sus funciones y dar cumplimiento a los programas de trabajo establecidos.',
  //   vision: 'Consolidar una Dependencia con vocación de servicio en colaboración con los diferentes Entes Públicos, sustentada en conceptos de calidad, sensibilidad, modernización y profesionalización, para el desempeño de sus atribuciones, ademas de participar en la determinación de las condiciones generales de trabajo, difundiendolas y vigilando su cumplimiento con base en una cultura de transparencia, bajo los valores de honestidad, responsabilidad y compromiso.',
  //   vigente_hasta: '31/12/2024',
  // }];

  const columnsUbicaciones = [
    {
      titleText: 'Lugar',
      dataIndex: 'lugar',
      key: 'lugar',
      width: 200,
    },
    {
      titleText: 'Especificación',
      dataIndex: 'especificacion',
      key: 'especificacion',
      width: 200,
    },
    {
      titleText: 'Orientación',
      dataIndex: 'orientacion',
      key: 'orientacion',
      width: 200,
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 200,
    },
  ];

  const columnsUbicacionesHistorico = [
    {
      titleText: 'Edificio',
      dataIndex: 'edificio',
      key: 'edificio',
      width: 200,
    },
    {
      titleText: 'Piso',
      dataIndex: 'piso',
      key: 'piso',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'area',
      key: 'area',
      width: 200,
    },
    {
      titleText: 'Oficina',
      dataIndex: 'oficina',
      key: 'oficina',
      width: 200,
    },
    {
      titleText: 'Otros',
      dataIndex: 'otros',
      key: 'otros',
      width: 200,
    },
    {
      titleText: 'Vigente Hasta',
      dataIndex: 'vigente_hasta',
      key: 'vigente_hasta',
      width: 200,
    },
  ];

  const columnsPlazasGlobales = [
    {
      titleText: 'Tipo de Contratación',
      dataIndex: 'tipoContratacion',
      key: 'tipoContratacion',
      width: 200,
    },
    // {
    //   titleText: 'Autorizadas',
    //   dataIndex: 'autorizadas',
    //   key: 'autorizadas',
    //   width: 200,
    // },
    {
      titleText: 'Ocupadas',
      dataIndex: 'ocupadas',
      key: 'ocupadas',
      width: 200,
    },
    {
      titleText: 'Vacantes',
      dataIndex: 'vacantes',
      key: 'vacantes',
      width: 200,
    },
    {
      titleText: 'Suspendidas',
      dataIndex: 'suspendidas',
      key: 'suspendidas',
      width: 200,
    },
    {
      titleText: 'Total',
      dataIndex: 'total',
      key: 'total',
      width: 200,
    },
  ];

  const columnsPlazasDesglose = [
    {
      titleText: 'Número de Plaza',
      dataIndex: 'numeroPlazaPuesto',
      key: 'numeroPlazaPuesto',
      width: 200,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipoEmpleado',
      key: 'tipoEmpleado',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto',
      key: 'puesto',
      width: 200,
    },
    {
      titleText: 'Tipo de Empleado de Nómina',
      dataIndex: 'tipoEmpleadoNomina',
      key: 'tipoEmpleadoNomina',
      width: 200,
    },
    {
      titleText: 'Número y Nombre de Empleado',
      dataIndex: 'numeroNombreEmpleado',
      key: 'numeroNombreEmpleado',
      width: 200,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estatus',
      key: 'estatus',
      width: 200,
    },
    {
      titleText: 'Sueldo Mensual',
      dataIndex: 'sueldoMensual',
      key: 'sueldoMensual',
      width: 160,
      align: 'right',
      render: (val) => currencyFormatter(val),
    },
    {
      titleText: 'Costo Total Estimado Anual',
      dataIndex: 'costoTotalEstimadoAnual',
      key: 'costoTotalEstimadoAnual',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val),
    },
  ];

  const columnsHistoricoDireccion = [
    {
      titleText: 'Tipo de Vialidad',
      dataIndex: 'tipo_de_vialidad',
      key: 'tipo_de_vialidad',
      width: 100,
      render: (val) => tiposVialidades.find((v) => v.id === val)?.descripcion || '',
    },
    {
      titleText: 'Vialidad',
      dataIndex: 'calle_principal',
      key: 'calle_principal',
      width: 100,
    },
    {
      titleText: 'Número Exterior',
      dataIndex: 'numero_exterior',
      key: 'numero_exterior',
      width: 100,
    },
    {
      titleText: 'Número Interior',
      dataIndex: 'numero_interior',
      key: 'numero_interior',
      width: 100,
    },
    {
      titleText: 'Colonia',
      dataIndex: 'colonia',
      key: 'colonia',
      width: 100,
    },
    // {
    //   titleText: 'Municipio',
    //   dataIndex: 'municipio',
    //   key: 'municipio',
    //   width: 100,
    // },
    // {
    //   titleText: 'Estado',
    //   dataIndex: 'estado',
    //   key: 'estado',
    //   width: 100,
    // },
    // {
    //   titleText: 'País',
    //   dataIndex: 'pais',
    //   key: 'pais',
    //   width: 100,
    // },
    {
      titleText: 'Código Postal',
      dataIndex: 'codigo_postal',
      key: 'codigo_postal',
      width: 100,
    },
    {
      titleText: 'Vigente Hasta',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 100,
    },
  ];

  const dataHistoricoDireccion = [
    {
      id: 1,
      tipo: 'Calle',
      vialidad: 'Reforma',
      numeroExterior: '1464',
      numeroInterior: '',
      colonia: 'Los Héroes Nacionales',
      municipio: 'Tlajomulco de Zúñiga',
      estado: 'Jalisco',
      pais: 'México',
      códigoPostal: '36641',
      vigenteHasta: '31/12/2024',
    },
  ];

  const columnsPuestosGlobal = [
    {
      titleText: 'Número de Puesto',
      dataIndex: 'numeroPuesto',
      key: 'numeroPuesto',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto',
      key: 'puesto',
      width: 'auto',
    },
    {
      titleText: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
      width: 100,
    },
  ];

  const mesesCosto = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
  ];

  // Mismas columnas de segmentos que Presupuesto Anual de Nómina (solo las configuradas) + lo
  // pagado por mes en las nóminas autorizadas
  const columnaSegmento = (titleText, dataIndex, width = 220) => ({
    titleText, dataIndex, key: dataIndex, width,
  });
  const columnaImporte = (titleText, dataIndex, width = 140) => ({
    titleText,
    dataIndex,
    key: dataIndex,
    width,
    align: 'right',
    render: (val) => currencyFormatter(val),
  });
  const columnsCosto = [
    columnaSegmento('Clave Presupuestal Completa', 'clave_presupuestal_completa', 280),
    columnaSegmento('Clasificador por Objeto del Gasto', 'cog_descripcion'),
    columnaSegmento('Área', 'directorio_de_area_descripcion', 200),
    columnaSegmento('Destino Presupuestal', 'destino_presupuestal_descripcion'),
    columnaSegmento('Programa', 'programa_descripcion'),
    columnaSegmento('Proyecto', 'proyecto_descripcion'),
    columnaSegmento('Función Presupuestal', 'funcion_presupuestal_descripcion'),
    columnaSegmento('Clasificación Administrativa', 'clasificacion_administrativa_descripcion'),
    columnaSegmento('Clasificación Funcional', 'clasificacion_funcional_descripcion'),
    columnaSegmento('Clasificación Programática', 'clasificacion_programatica_descripcion'),
    columnaSegmento('Tipo de Gasto', 'tipo_de_gasto_descripcion'),
    columnaSegmento('Fuente de Financiamiento', 'fuente_financiamiento_descripcion'),
    columnaSegmento('Tipo de Nómina Empleado', 'tipo_de_nomina_empleado_descripcion'),
    columnaSegmento('Plan de Cuentas', 'cuenta_contable_conac_descripcion'),
    columnaSegmento('Cuenta Contable', 'cuenta_contable_descripcion'),
  ].filter((col) => !CAMPO_POR_COLUMNA[col.dataIndex]
    || segmentoAplica(segmentosEgreso, CAMPO_POR_COLUMNA[col.dataIndex]))
    .concat(mesesCosto.map((mes, idx) => columnaImporte(mes, `mes_${idx + 1}_importe`)))
    .concat([columnaImporte('Total Pagado', 'total_pagado', 160)]);

  const dataCosto = costoArea.claves.length
    ? [
      ...costoArea.claves,
      mesesCosto.reduce((fila, _mes, idx) => ({
        ...fila,
        [`mes_${idx + 1}_importe`]: costoArea.claves
          .reduce((total, clave) => total + (Number(clave[`mes_${idx + 1}_importe`]) || 0), 0),
      }), {
        id: 'TOTAL',
        clave_presupuestal_completa: 'TOTAL',
        total_pagado: costoArea.claves.reduce((total, clave) => total + (Number(clave.total_pagado) || 0), 0),
      }),
    ]
    : [];

  const dataUbicacionesHistorico = [{
    id: 1,
    edificio: 'Jardín Principal',
    piso: 'Planta Baja',
    area: 'Recursos Humanos',
    oficina: '',
    otros: '',
    vigente_hasta: '',
  }];

  const dataUbicaciones = [
    {
      id: 1,
      lugar: 'Edificio',
      especificacion: 'CAT',
      orientacion: '',
      observaciones: '',
    },
  ];



  // #endregion variables

  // #region useEffect
  useEffect(() => {
    fetchInitialData();
    onCancelAddEditArea();
  }, []);

  // Pestañas Plazas y Puestos: se arman por PLAZA del Área (no por el historial de asignaciones)
  useEffect(() => {
    let mounted = true;
    const limpiarTablas = () => {
      setTablaPlazasDataSource([]);
      setTablaPlazasDesgloseDataSource([]);
      setTablaPuestosGlobalDataSource([]);
    };

    const getDataPlazasGlobales = (plazas) => {
      // Una fila por Tipo de Contratación; Total = Ocupadas + Vacantes + Suspendidas
      const columnaPorEstatus = { ASIGNADA: 'ocupadas', DISPONIBLE: 'vacantes', SUSPENDIDA: 'suspendidas' };
      const filas = new Map();
      const totales = {
        id: 'TOTAL', tipoContratacion: 'TOTAL', ocupadas: 0, vacantes: 0, suspendidas: 0, total: 0,
      };
      plazas.forEach((plaza) => {
        const columna = columnaPorEstatus[plaza.estado_plaza];
        if (!columna) {
          return;
        }
        const tipoContratacion = plaza.tipo_de_contratacion || 'SIN TIPO DE CONTRATACIÓN';
        if (!filas.has(tipoContratacion)) {
          filas.set(tipoContratacion, {
            id: tipoContratacion, tipoContratacion, ocupadas: 0, vacantes: 0, suspendidas: 0, total: 0,
          });
        }
        const fila = filas.get(tipoContratacion);
        fila[columna] += 1;
        fila.total += 1;
        totales[columna] += 1;
        totales.total += 1;
      });
      const ordenadas = Array.from(filas.values())
        .sort((a, b) => a.tipoContratacion.localeCompare(b.tipoContratacion));
      setTablaPlazasDataSource([...ordenadas, totales]);
    };

    const getDataPlazasDesgloseGlobales = (plazas) => {
      setTablaPlazasDesgloseDataSource(plazas.map((plaza) => ({
        id: plaza.plaza_id,
        numeroPlazaPuesto: plaza.plaza_clave,
        puesto: plaza.puesto,
        tipoEmpleado: plaza.tipo_de_empleado,
        tipoEmpleadoNomina: plaza.tipo_de_nomina_empleado,
        numeroNombreEmpleado: plaza.numero_y_nombre_ocupante,
        estatus: plaza.estado_plaza,
        sueldoMensual: plaza.sueldo_mensual,
        costoTotalEstimadoAnual: plaza.costo_total_estimado_anual,
      })));
    };

    const getTotalPlacementsCount = (plazas) => {
      const count = new Map();
      plazas.forEach((plaza) => {
        const llave = plaza.puesto_id ?? 'SIN_PUESTO';
        if (count.has(llave)) {
          count.get(llave).cantidad += 1;
        } else {
          count.set(llave, {
            id: llave,
            numeroPuesto: plaza.puesto_clave,
            puesto: plaza.puesto || 'SIN PUESTO',
            cantidad: 1,
          });
        }
      });
      setTablaPuestosGlobalDataSource(Array.from(count.values())
        .sort((a, b) => String(a.numeroPuesto ?? '').localeCompare(String(b.numeroPuesto ?? ''), 'es', { numeric: true })));
    };

    const fetchPlazasDeArea = async () => {
      if (!isEditingAreaMode || !selectedArea?.id) {
        limpiarTablas();
        return;
      }
      const plazas = await getPlazasDeArea({ directorio_area: selectedArea.id });
      if (!mounted) {
        return;
      }
      getDataPlazasGlobales(plazas);
      getDataPlazasDesgloseGlobales(plazas);
      getTotalPlacementsCount(plazas);
    };

    fetchPlazasDeArea();
    return () => {
      mounted = false;
    };
  }, [selectedArea?.id, isEditingAreaMode]);

  // Pestaña Costo: catálogos (periodos fiscales y segmentos configurados) una sola vez
  useEffect(() => {
    let mounted = true;
    const fetchCatalogosCosto = async () => {
      if (!isEditingAreaMode || segmentosEgreso !== undefined) {
        return;
      }
      const [_periodosFiscales, _segmentos] = await Promise.all([
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        API.get(URIconfiguracionesDeSegmentosPresupuestales, {
          params: { estados_globales: ESTATUS_AUTORIZADO, tipo_de_presupuesto: TIPO_PRESUPUESTO_EGRESO },
        })
          .then(({ data }) => getSegmentosDeConfiguracion((data || [])[0]?.id))
          .catch(() => null),
      ]);
      if (mounted) {
        setPeriodosFiscales(_periodosFiscales);
        setSegmentosEgreso(_segmentos);
      }
    };
    fetchCatalogosCosto();
    return () => {
      mounted = false;
    };
  }, [isEditingAreaMode]);

  // Pestaña Costo: lo pagado en las nóminas autorizadas del periodo fiscal elegido (en curso por defecto)
  useEffect(() => {
    let mounted = true;
    const fetchCosto = async () => {
      if (!isEditingAreaMode || !selectedArea?.id) {
        setCostoArea({ periodo_fiscal: null, claves: [] });
        return;
      }
      setLoadingCosto(true);
      const response = await getCostoDeArea({
        directorio_area: selectedArea.id,
        periodo_fiscal: costoPeriodoFiscal || undefined,
      });
      if (mounted) {
        setCostoArea({ periodo_fiscal: response?.periodo_fiscal ?? null, claves: response?.claves || [] });
        setLoadingCosto(false);
      }
    };
    fetchCosto();
    return () => {
      mounted = false;
    };
  }, [selectedArea?.id, isEditingAreaMode, costoPeriodoFiscal]);

  useEffect(() => {
    reloadAreasTable();
  }, [selectedEstructuraJerarquica]);

  useEffect(() => {
    // Si hay algún filtro por columna activo → mostramos advertencia
    const hasColumnFilter = Object.values(columnFilters).some((v) => v && v.trim() !== '');
    setShowColumnFilterWarning(hasColumnFilter);
  }, [columnFilters]);


  // #endregion useEffect

  // #region main view
  const filteredTree = filterTreeRecursively(directorioDeAreasActualTree);

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      const areaId = selectedArea?.id;
      if (selectedRowKeys.length && areaId) {
        const deleted = await deleteArea(areaId);

        if (deleted) {
          onSuccess(null, 'Área eliminada correctamente');

          //  1. Actualiza lista local
          const newAreas = directorioDeAreasCompleto.filter(
            (area) => area.id !== areaId,
          );
          setDirectorioDeAreasCompleto(newAreas);

          //  2. Recarga árbol con nueva lista
          reloadAreasTable(newAreas);

          // 3. Limpia selección
          setVisibleAlert(false);
          setSelectedRowKeys([]);
          setSelectedArea(null);
        }
      }
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  // --- 1. Lógica de Búsqueda Plana (Extrae solo coincidencias) ---
  const getFlatMatches = (nodes, term) => {
    let matches = [];
    if (!nodes) return matches;

    const lowerSearch = term.toLowerCase().trim();

    nodes.forEach((node) => {
      // Verificamos si el nodo actual coincide con la búsqueda
      const isMatch = (node.clave?.toLowerCase().includes(lowerSearch))
        || (node.nombre?.toLowerCase().includes(lowerSearch));

      if (isMatch) {
        // TRUCO: Si coincide, agregamos una copia del nodo PERO sin hijos.
        // Al poner children: undefined, la tabla lo renderiza como una fila suelta sin el icono de "+"
        matches.push({ ...node, children: undefined });
      }

      // Independientemente de si el padre coincidió, buscamos en sus hijos
      // por si hay coincidencias internas que también debamos mostrar.
      if (node.children && node.children.length > 0) {
        const childMatches = getFlatMatches(node.children, term);
        matches = matches.concat(childMatches);
      }
    });

    return matches;
  };

  // --- 2. Cálculo de datos (Árbol normal vs Lista plana) ---
  const filteredData = React.useMemo(() => {
    if (!searchText || searchText.trim() === '') {
      // Si NO hay búsqueda, mostramos el árbol completo original con su jerarquía
      return directorioDeAreasActualTree;
    }
    // Si SI hay búsqueda, usamos la función que aplana y solo trae coincidencias
    return getFlatMatches(directorioDeAreasActualTree, searchText);
  }, [directorioDeAreasActualTree, searchText]);
  // --- 5. Manejador del Switch "Abrir Todo" ---
  const onToggleExpandAll = (checked) => {
    setExpandAll(checked);
    if (checked) {
      // Expandimos los datos que se están viendo actualmente (filtrados o completos)
      const keysToExpand = getAllKeys(filteredData);
      setExpandedRowKeys(keysToExpand);
    } else {
      setExpandedRowKeys([]);
    }
  };


  // --- 3. Efecto: Control de expansión ---
  useEffect(() => {
    if (searchText && searchText.trim() !== '') {
      // Modo Búsqueda: Al ser lista plana, no hay nada que expandir.
      // Limpiamos las llaves para que no se quede nada abierto raro.
      setExpandedRowKeys([]);
    } else {
      // Modo Normal (limpio): Colapsamos todo (o lo dejas como prefieras)
      setExpandedRowKeys([]);
      setExpandAll(false);
    }
  }, [searchText]); // Quitamos 'filteredData' de dependencias aquí para simplificar el reset

  // --- 6. Manejador manual de expansión (click en flechitas) ---
  const onExpand = (expanded, record) => {
    const keys = [...expandedRowKeys];
    if (expanded) {
      keys.push(record.key);
    } else {
      const index = keys.indexOf(record.key);
      if (index > -1) {
        keys.splice(index, 1);
      }
    }
    setExpandedRowKeys(keys);
    // Nota: No apagamos el switch 'setExpandAll(false)' aquí para no causar UX extraña,
    // pero podrías hacerlo si quieres que el switch se apague al cerrar un nodo manualmente.
  };



  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={isLoadingVisible}>
        {!(isAddingAreaMode || isEditingAreaMode) ? (
          <>
            <Form
              layout="vertical"
              form={mainForm}
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={24} xl={8}>
                  <Form.Item
                    name="nombre_estructura_jerarquica"
                    label="Estructura Jerárquica"
                  >
                    <Select
                      keyProp="id"
                      labelProp="nombre"
                      dataSource={estructurasJerarquicas}
                      disabled={isNivelesJerarquicosDisabled}
                      onChange={(item) => {
                        if (item) {
                          const estructuraSeleccionada = estructurasJerarquicas.find((estructura) => estructura.id === item);
                          mainForm.setFieldValue('vigente_hasta', estructuraSeleccionada?.vigencia_fin ? Moment(estructuraSeleccionada?.vigencia_fin) : null);
                          setSelectedEstructuraJerarquica(estructuraSeleccionada);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="vigente_hasta"
                    label="Vigente Hasta"
                    hasFeedback
                  >
                    <DatePicker
                      disabled
                      format="DD/MM/YYYY"
                      placeholder=""
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            {/* Mensaje informativo cuando se detecta intento de uso de filtros por columna */}
            {showColumnFilterWarning && (
              <Alert
                message="En esta página usa el buscador superior para filtrar (incluye subáreas). Los filtros por columna están deshabilitados aquí."
                type="info"
                showIcon
                closable
                onClose={() => setShowColumnFilterWarning(false)}
                style={{ marginBottom: 16 }}
              />
            )}

            {/* Buscador global - siempre visible y funcional */}
            <Row style={{ marginBottom: 16 }}>
              <Col>
                <span style={{ marginRight: 8 }}>Abrir Todo el Directorio:</span>
                <Switch
                  checked={expandAll}
                  onChange={onToggleExpandAll}
                  checkedChildren="Sí"
                  unCheckedChildren="No"
                />
              </Col>
              <Col span={24} style={{ marginTop: 10 }}>
                <Input.Search
                  placeholder="Buscar área por nombre o clave..."
                  allowClear
                  enterButton={false}
                  size="large"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  // onSearch no es estrictamente necesario si usamos onChange, pero lo dejamos
                  onSearch={(value) => setSearchText(value)}
                  style={{ maxWidth: 500 }}
                />
              </Col>
            </Row>

            <Table
              cols={columns}
              rowKey="key"
              // CAMBIO PRINCIPAL: Usamos 'filteredData' que ya contiene la lógica de búsqueda recursiva
              customDataArbolado={filteredData}
              data={filteredData}
              filterNested
              // Mantenemos tu lógica de filtros por columna tal cual la tenías
              onChange={(pagination, filters) => {
                const simplified = {};
                Object.entries(filters).forEach(([key, val]) => {
                  if (val && val.length > 0) {
                    const [first] = val;
                    simplified[key] = first;
                  }
                });
                setColumnFilters(simplified);
              }}
              // CONFIGURACIÓN DE EXPANSIÓN: Conecta el Switch y el Buscador con la tabla
              expandable={{
                expandedRowKeys: expandedRowKeys,
                onExpand: onExpand,
              }}
              rowSelection={rowSelection}
              allowImport
              baseURI={baseURI}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd: onClickAddArea,
                onClickEdit: onClickEditArea,
                onClickDelete,
              }}
              customActions={[
                {
                  onClick: () => { setIsModalAuthorizeAreaVisible(true); },
                  text: 'Autorizar Área',
                  icon: <CheckCircleOutlined />,
                  disabledBySelection: false,
                  className: 'success',
                  disabled: selectedRowKeys.length === 0,
                },
              ]}
              disableAdd={!selectedEstructuraJerarquica}
              disableEdit={!(selectedRowKeys && selectedEstructuraJerarquica?.estados_globales !== ESTATUS_INACTIVO)}
              permission={{
                hasAllViewPermission: true,
                add: true,
                change: true,
                delete: true,
              }}
              hasAllViewPermission
              allowExportPDF={false}
              allowSearch={false}
            />
          </>
        ) : (
          <Card
            className="form-container"
            title={`${isEditingAreaMode ? 'Editar' : 'Agregar'} Área`}
            extra={(
              <FormSubmitControls
                onFinish={onFinishAddEditArea}
                onCancel={onCancelAddEditArea}
                loading={isLoadingVisible}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            <Tabs
              activeKey={currentTabKey}
              onChange={mutable ? onChangeTabKey : setCurrentTabKey}
              type="card"
            >
              <TabPane
                tab={(
                  <span>
                    <HomeOutlined />
                    Datos Generales
                  </span>
                )}
                key="general"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={addingEditingForm}
                  onFinish={() => {
                  }}
                  scrollToFirstError
                  name="general"
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="nombre_estructuraJerarquica"
                        label="Nombre de la estructura Jerárquica"
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="vigenteHasta_estructuraJerarquica"
                        label="Vigencia Hasta"
                        hasFeedback
                      >
                        <DatePicker
                          disabled
                          format="DD/MM/YYYY"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="estatus_estructuraJerarquica"
                        label="Estatus"
                        hasFeedback
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </TabPane>

              <TabPane
                tab={(
                  <span>
                    <BarsOutlined />
                    Áreas
                  </span>
                )}
                key="areas"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={addingEditingForm}
                  name="areas"
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="nivelSuperior_areas"
                        label="Nivel superior"
                        hasFeedback
                      >
                        <TreeSelect
                          treeData={directorioDeAreasActualNormalizadaTreeSelect}
                          placeholder="Selecciona un área (o vacío para nodo raíz)"
                          onChange={(value) => {
                            if (value) {
                              const areaSeleccionada = directorioDeAreasCompleto.find((area) => area.id === value);
                              addingEditingForm.setFieldValue('clave_areas', areaSeleccionada?.clave || '');

                              // Calcular y setear la coordinación automáticamente
                              const coord = getNombreCoordinacion(value);
                              addingEditingForm.setFieldValue('coordinacion_areas', coord);
                            } else {
                              // Si no hay padre, se limpia (o se toma lógica por defecto)
                              const areaDefault = directorioDeAreasCompleto.find((area) => area.id === selectedRowKeys[0]);
                              addingEditingForm.setFieldValue('clave_areas', areaDefault?.clave || '');
                              addingEditingForm.setFieldValue('coordinacion_areas', '');
                            }
                          }}
                          allowClear
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="coordinacion_areas"
                        label="Coordinación"
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="clave_areas"
                        label="Clave"
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={false}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="nombre_areas"
                        label="Nombre"
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={false}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="nivelJerarquico_areas"
                        label="Nivel Jerárquico"
                        hasFeedback
                      >
                        <Select
                          keyProp="id"
                          labelProp="clave"
                          dataSource={nivelesJerarquicos}
                          render={(item) => `${item?.nivel} - ${item?.descripcion}`}
                        />
                      </Form.Item>
                    </Col>
                    {/* <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="estatus_areas"
                        label="Estatus"
                        hasFeedback
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col> */}
                  </Row>
                </Form>
              </TabPane>

              {/* Resto de las tabs (Misión y Visión, Plazas, Puestos, Presupuestos, Dirección, Ubicación) */}
              {/* Mantengo todo igual que en tu versión original que funcionaba */}
              <TabPane
                tab={(
                  <span>
                    <AimOutlined />
                    {' '}
                    Misión y Visión
                  </span>
                )}
                key="misionVision"
                forceRender
              >

                <Card
                  title="Misión y Visión"
                  bordered={false}
                  bodyStyle={{ height: 'auto', minHeight: 0, overflow: 'visible' }}
                  extra={
                    [
                      <Button type="link" icon={<PlusOutlined />} onClick={() => onClickAddMisionVision()}>Agregar</Button>,
                      <Button type="link" icon={<EditOutlined />} onClick={() => onClickEditMisionVision()} disabled={!(misionVisionVisibleForm.getFieldValue('misionActual') || misionVisionVisibleForm.getFieldValue('visionActual'))}>Editar</Button>,
                      // <Button icon={<DeleteOutlined />} onClick={() => onClickDeleteMisionVision()} disabled={!(misionVisionVisibleForm.getFieldValue('misionActual') || misionVisionVisibleForm.getFieldValue('visionActual'))}>Eliminar</Button>,
                    ]
                  }
                >
                  <Form
                    layout="vertical"
                    form={misionVisionVisibleForm}
                    name="misionVisionVisibleForm"
                  >

                    <Row gutter={10}>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="misionActual"
                          label="Misión Actual"
                        >
                          <TextArea rows={4} disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="visionActual"
                          label="Visión Actual"
                        >
                          <TextArea rows={4} disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="vigenciaFinalActual"
                          label="Vigencia Final"
                        >
                          <DatePicker
                            placeholder=""
                            format="DD/MM/YYYY"
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>



                </Card>

                <Card
                  title="Histórico"
                  bordered={false}
                  style={{ marginTop: 16 }}
                >
                  <Table
                    cols={columnsMisionesHistorico}
                    data={dataMisionesHistorico?.reverse()}
                    rowKey="key"
                    rowSelection={rowSelection}
                    hasAllViewPermission
                  />
                </Card>
              </TabPane>

              {isEditingAreaMode && (
                <>
                  <TabPane
                    tab={(
                      <span>
                        <UserOutlined />
                        {' '}
                        Plazas
                      </span>
                    )}
                    key="plazas"
                    forceRender
                  >
                    <div>
                      <Card
                        title="Plazas globales"
                        bordered={false}
                        bodyStyle={{ height: 'auto', minHeight: 0, overflow: 'visible' }}
                      >
                        <Table
                          cols={columnsPlazasGlobales}
                          data={tablaPlazasDataSource}
                        />
                      </Card>
                      <Card
                        title="Desglose de Plazas"
                        bordered={false}
                      >
                        <Table
                          cols={columnsPlazasDesglose}
                          data={tablaPlazasDesgloseDataSource}
                          allowAdd={false}
                          allowEdit={false}
                          allowDelete={false}
                        />
                      </Card>
                    </div>
                  </TabPane>

                  <TabPane
                    tab={(
                      <span>
                        <UserOutlined />
                        {' '}
                        Puestos
                      </span>
                    )}
                    key="puestos"
                    forceRender
                  >
                    <div>
                      <Card
                        title="Global"
                        bordered={false}
                      >
                        <Row>
                          <Col xs={24} sm={24} md={24} xl={12} xxl={12}>
                            <Table
                              cols={columnsPuestosGlobal}
                              data={tablaPuestosGlobalDataSource}
                            />
                          </Col>
                        </Row>
                      </Card>
                    </div>
                  </TabPane>



                  <TabPane
                    tab={(
                      <span>
                        <UserOutlined />
                        {' '}
                        Costo
                      </span>
                    )}
                    key="presupuestos"
                    forceRender
                  >
                    <Spin spinning={loadingCosto}>
                      <Row gutter={10}>
                        <Col xs={24} sm={12} md={8} xl={6}>
                          <Form.Item label="Periodo Fiscal">
                            <Select
                              keyProp="id"
                              labelProp="descripcion"
                              dataSource={periodosFiscales}
                              value={costoPeriodoFiscal || costoArea.periodo_fiscal}
                              onChange={(val) => setCostoPeriodoFiscal(val || null)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Alert
                        type="info"
                        showIcon
                        message={'Lo pagado se obtiene de las nóminas autorizadas de las plazas del Área y se '
                          + 'relaciona con cada clave por su Cuenta Contable, Clasificador por Objeto del Gasto '
                          + 'y Fuente de Financiamiento. Lo que no corresponde a ninguna clave del Área se '
                          + 'muestra como "Sin clave presupuestal".'}
                        style={{ marginBottom: 10 }}
                      />
                      <Table
                        cols={columnsCosto}
                        data={dataCosto}
                      />
                    </Spin>
                  </TabPane>
                </>
              )}
              <TabPane
                tab={(
                  <span>
                    <HomeOutlined />
                    {' '}
                    Dirección
                  </span>
                )}
                key="direccion"
                forceRender
              >
                <Col span={24}>
                  <Card
                    title="Dirección"
                    bordered={false}
                    bodyStyle={{ height: 'auto', minHeight: 0, overflow: 'visible' }}
                    extra={
                      [
                        <Button type="link" disabled={isAddingAddressMode || isEditingAddressMode} icon={<PlusOutlined />} onClick={() => onClickAddAddress()}>Agregar</Button>,
                        <Button type="link" disabled={!(isAddingAddressMode || isEditingAddressMode)} icon={<SaveOutlined />} onClick={() => onClickSaveAddress()}>Guardar</Button>,
                        <Button type="link" disabled={!(isAddingAddressMode || isEditingAddressMode)} icon={<DeleteOutlined />} onClick={() => onClickCancelAddress()}>Cancelar</Button>,
                      ]
                    }
                  >
                    <DireccionEntidad
                      formDireccion={formDireccion}
                      rules={{
                        required: [{ required: true }],
                      }}
                      coloniasCargadas={coloniasCargadas}
                      paises={paises}
                      mutable={!disabled}
                      disabled={isAddressFormDisabled}
                    />
                    <Form
                      layout="vertical"
                      form={endDateAddressForm}
                      scrollToFirstError
                      name="endDateAddressModalForm"
                    >

                      <Col md={8}>
                        <Form.Item
                          name="vigencia_final"
                          label="Vigencia Final"
                          rules={[formsRules.requiredRule]}
                          hasFeedback
                        >
                          <DatePicker
                            placeholder=""
                            format="DD/MM/YYYY"
                            disabled={isAddressFormDisabled}
                          />
                        </Form.Item>
                      </Col>
                    </Form>
                  </Card>

                  <Card
                    title="Histórico de Direcciones"
                    bordered={false}

                  >
                    <Table
                      cols={columnsHistoricoDireccion}
                      data={historicoDirecciones?.reverse()}
                      allowAdd={false}
                      allowEdit={false}
                      allowDelete={false}
                    />
                  </Card>
                </Col>
              </TabPane>

              <TabPane
                tab={(
                  <span>
                    <EnvironmentOutlined />
                    {' '}
                    Ubicación
                  </span>
                )}
                key="ubicacion"
                forceRender
              >
                <Card
                  title="Ubicación"
                  bordered={false}
                  bodyStyle={{ height: 'auto', minHeight: 0, overflow: 'visible' }}
                  extra={
                    [
                      <Button type="link" disabled={isAddingLocationMode || isEditingLocationMode} icon={<PlusOutlined />} onClick={() => onClickAddLocation()}>Agregar</Button>,
                      <Button type="link" disabled={!(isAddingLocationMode || isEditingLocationMode)} icon={<SaveOutlined />} onClick={() => onClickSaveLocation()}>Guardar</Button>,
                      <Button type="link" disabled={!(isAddingLocationMode || isEditingLocationMode)} icon={<DeleteOutlined />} onClick={() => onClickCancelLocation()}>Cancelar</Button>,
                    ]
                  }
                >
                  <Form
                    layout="vertical"
                    form={formUbicacion}
                    scrollToFirstErrorvb
                    disabled={isLocationFormDisabled}
                    name="ubicacion"
                  >
                    <Row gutter={10}>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Lugar"
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Especificación"
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Orientación"
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Observaciones"
                        />
                      </Col>
                    </Row>
                    <Row gutter={10}>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Edificio"
                        />
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="edificio_especificacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col md={6}>
                        <Form.Item
                          name="edificio_orientacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="edificio_observaciones"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Piso"
                        />
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="piso_especificacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col md={6}>
                        <Form.Item
                          name="piso_orientacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="piso_observaciones"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Área"
                        />
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="area_especificacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col md={6}>
                        <Form.Item
                          name="area_orientacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="area_observaciones"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={10}>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Oficina"
                        />
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="oficina_especificacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col md={6}>
                        <Form.Item
                          name="oficina_orientacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="oficina_observaciones"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col md={6}>
                        <Input
                          disabled
                          defaultValue="Otros"
                        />
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="otros_especificacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col md={6}>
                        <Form.Item
                          name="otros_orientacion"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <Form.Item
                          name="otros_observaciones"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                  </Form>
                </Card>

                <Card
                  title="Histórico"
                  bordered={false}
                >
                  <Table
                    cols={columnsUbicacionesHistorico}
                    data={dataUbicacionesHistorico}
                    allowAdd={false}
                    allowEdit={false}
                    allowDelete={false}
                  />
                </Card>
              </TabPane>
            </Tabs>
          </Card>
        )}
      </Spin>

      {/* Modal de Misión y Visión */}
      <Modal
        open={isMisionVisionModalVisible}
        closable={false}
        maskClosable={false}
        width={500}
        footer={null}
        title={(
          <FormSubmitControls
            label={`${isEdittingMisionVisionMode ? 'Editar' : 'Agregar'} Misión y Visión`}
            onFinish={async () => {
              try {
                const values = await misionVisionModalForm.validateFields();
                // Agregando nueva área
                // if (isAddingMisionVision || isEdittingMisionVision) {
                if (isAddingAreaMode) {
                  // Agregando o editando misión y visión al crear nueva área
                  misionVisionVisibleForm.setFieldsValue({
                    misionActual: formMisionVisionModalValues.mision,
                    visionActual: formMisionVisionModalValues.vision,
                    vigenciaFinalActual: formMisionVisionModalValues.vigencia_final,
                  });
                  setIsMisionVisionModalVisible(false);
                } else if (isEditingAreaMode) {
                  // Editando misión y visión en área existente
                  setIsLoadingVisible(true);
                  const params = {
                    directorio_area: selectedArea.id,
                    mision: formMisionVisionModalValues.mision,
                    vision: formMisionVisionModalValues.vision,
                    vigencia_final: formMisionVisionModalValues.vigencia_final.format(DATE_FORMATS[1]),
                    estados_globales: ESTATUS_ACTIVO,
                  };

                  const response = await createMisionVision(params);
                  if (response) {
                    await cargarMisionesVisiones();
                  }
                  setIsLoadingVisible(false);
                  await cargarMisionesVisiones();
                }
                setIsMisionVisionModalVisible(false);
              } catch (errorInfo) {
                setIsLoadingVisible(false);
                // Si fue por validación de campos, antd ya lo muestra; si no,
                // dejamos rastro para diagnóstico (createMisionVision ya avisa
                // vía onError los errores de red/backend).
                if (!errorInfo?.errorFields) {
                  // eslint-disable-next-line no-console
                  console.error('[Directorio de Áreas] error al guardar misión y visión', errorInfo);
                }
              }
            }}
            onCancel={() => {
              setIsMisionVisionModalVisible(false);
            }}
            allowSave
          />
        )}
      // forceRender
      >
        <Form
          layout="vertical"
          form={misionVisionModalForm}
          scrollToFirstError
          name="misionVisionModalForm"
        >
          <Col xs={24} sm={24} md={24}>
            <Form.Item
              name="mision"
              label="Misión"
              rules={[formsRules.requiredRule]}
              hasFeedback
            >
              <TextArea
                rows={4}
                disabled={false}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24}>
            <Form.Item
              name="vision"
              label="Visión"
              rules={[formsRules.requiredRule]}
              hasFeedback
            >
              <TextArea
                rows={4}
                disabled={false}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24}>
            <Form.Item
              name="vigencia_final"
              label="Vigencia Final"
              hasFeedback
            >
              <DatePicker
                placeholder=""
                format="DD/MM/YYYY"
              />
            </Form.Item>
          </Col>
        </Form>
      </Modal>

      {/* Modal de Autorizar Área */}
      <ModalConfirmation
        title="Autorizar área(s)"
        contentTitle={`¿Estás seguro de cambiar el estatus a AUTORIZADO para ${selectedRowKeys.length} registro(s)?`}
        onFinish={async () => {
          setIsLoadingVisible(true); // Mostrar spinner
          try {
            // CORRECCIÓN: Iteramos sobre todos los IDs seleccionados
            // Creamos un array de promesas para ejecutarlas en paralelo
            const promesasAutorizacion = selectedRowKeys.map((id) => autorizarArea(id));

            // Esperamos a que todas terminen
            await Promise.all(promesasAutorizacion);

            onSuccess(null, 'Áreas autorizadas correctamente');
            await fetchInitialData(true); // Recargar tabla
            setSelectedRowKeys([]); // Limpiar selección
            setSelectedArea(null);
          } catch (error) {
            onError(error, setIsLoadingVisible);
          } finally {
            setIsLoadingVisible(false);
            setIsModalAuthorizeAreaVisible(false);
          }
        }}
        onFinishText="Autorizar"
        onFinishIcon={<CheckCircleOutlined />}
        onCancel={() => setIsModalAuthorizeAreaVisible(false)}
        onCancelIcon={<ArrowLeftOutlined />}
        loading={isLoadingVisible}
        open={isModalAuthorizeAreaVisible}
      />

      {/* Modal de Eliminar */}
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => setVisibleAlert(false)}
        open={visibleAlert}
        content={selectedArea ? ` el área "${selectedArea.nombre}"?` : '¿Deseas eliminar el registro seleccionado?'}
        loading={loading}
      />
    </Row>
  );

  // #endregion main view
}

export default DirectorioAreas;
